import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToTopOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname) {
      return;
    }

    window.scrollTo({
      left: 0,
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);
};
